import { Address } from "./address";

export class User {
    id: number = null;
    title: string = "Mr.";
    gender: string = "Male";
    firstName: string;
    lastName: string;
    email: string;
    address: Address = new Address();
    phoneNo: string;
    password: string;
    roleName: string = "ROLE_PROGRAM_LEAD";
    accountId: any = null;
    providerId: any = null;
    canDoPayment: boolean = false;
    accountsMapped:string = null;
    providersMapped:string = null;
    dateFormat:any;
    isLoginOTPRequired:boolean=false;
    accountName: string;
}